import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { closeMiniApp } from '@telegram-apps/sdk-react';
import CorporateDialog from '@components/dialogs/CorporateDialog.component.jsx';
import CorporateLayout from '@layouts/Corporate.layout.jsx';

function ErrorBoundaryComponent({ errorType }) {
  const { t } = useTranslation();

  const type = useMemo(
    () => ({
      ERR_NOT_SUPPORTED: {
        title: t('unsupportedDevice.title'),
        description: t('unsupportedDevice.description'),
      },
      ERR_ENVIRONMENT: {
        title: t('environment.title'),
        description: t('environment.description'),
      },
    }),
    [t],
  );

  const title = type[errorType]?.title || t('common.error.title');
  const description =
    type[errorType]?.description || t('common.error.description');

  return (
    <CorporateLayout>
      <CorporateDialog
        title={title}
        description={description}
        buttonText={t('common.close')}
        onButtonClick={() => closeMiniApp()}
      />
    </CorporateLayout>
  );
}

export default ErrorBoundaryComponent;
